const GARANTI_PROVIDER = 'garanti';

const norm = (value) => String(value || '').trim();
const normLower = (value) => norm(value).toLowerCase();

const isGarantiProvider = (record) => normLower(record?.provider || record?.bank) === GARANTI_PROVIDER;

/**
 * Garanti mock işaretleri — yalnızca MockGarantiAdapter'ın ürettiği kesin imzalar.
 * Gerçek garanti-api kaynaklı kayıtlar (source: garanti-api) asla mock sayılmaz.
 */
const isGarantiMockRecord = (record) => {
  if (record.isMock === true) return true;
  const source = normLower(record.source);
  if (source === 'mock-garanti' || source.includes('mock-garanti')) return true;
  if (normLower(record.syncStatus) === 'mock-akis') return true;
  if (/^mock-garanti/i.test(norm(record.externalTxId))) return true;
  return false;
};

/** Kesin mock banka kaydı — canlı Garanti (garanti-api) asla mock sayılmaz. */
export const isMockBankingRecord = (record) => {
  if (!record || typeof record !== 'object') return false;
  if (isGarantiProvider(record)) return isGarantiMockRecord(record);

  if (record.isMock === true) return true;

  const provider = normLower(record.provider);
  const adapter = normLower(record.adapter);
  const syncStatus = normLower(record.syncStatus);
  const source = normLower(record.source);
  const externalTxId = norm(record.externalTxId);
  const reference = norm(record.reference);
  const description = norm(record.description);

  if (provider.includes('mock')) return true;
  if (adapter.includes('mock')) return true;
  if (syncStatus.includes('mock')) return true;
  if (source.includes('mock')) return true;
  if (/^mock/i.test(externalTxId)) return true;
  if (/^mock/i.test(reference)) return true;
  if (/^mock\s/i.test(description)) return true;

  return false;
};

export const isMockBankingState = (state) => isMockBankingRecord(state);
